import { useEffect } from "react";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router";
import { getJson } from "../api";
import { useTexts } from "../texts";
import { Loading } from "../ui/kit";

// Redirecciones de las rutas viejas de IA (especificación §4): cada una llega a su destino nuevo con la misma ruta, el
// mismo alcance o el mismo proveedor. Nunca una página en blanco: mientras se resuelve, «Cargando».

/**
 * /Ai/Config/Conectar → la ficha del proveedor con la ventana «Agregar API key» (sin proveedor, a Proveedores: un
 * proveedor no se «conecta», se le agrega una API key dentro). /Ai/Asignacion/*, /Ai/Routing/Index y
 * /Ai/UsoModelos/Index → /Ai/Rutas con la misma ruta y alcance.
 */
export function LegacyAiRedirect({ kind }: { kind: "connect" | "routes" }) {
  const [params] = useSearchParams();
  if (kind === "connect") {
    const provider = params.get("provider");
    return (
      <Navigate
        replace
        to={provider ? `/Ai/Providers/${encodeURIComponent(provider)}?conectar=1` : "/Ai/Providers/Index"}
      />
    );
  }
  const target = new URLSearchParams({ route: params.get("route") || "TEXT_CHAT" });
  const organization = Number(params.get("organizationId"));
  if (Number.isSafeInteger(organization) && organization > 0) target.set("organizationId", String(organization));
  return <Navigate replace to={`/Ai/Rutas?${target}`} />;
}

/**
 * /Ai/Conexiones/Detail/{id} y /Ai/Providers/Connection/{id} → la ficha del proveedor de esa conexión;
 * /Ai/Conexiones/AgregarClave?connectionId= → esa ficha con la ventana «Agregar API key».
 */
export function ConnectionRedirect({ query = "id", addKey }: { query?: string; addKey?: boolean }) {
  const { L } = useTexts();
  const { id } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const value = Number(id ?? params.get(query));
  const valid = Number.isSafeInteger(value) && value > 0;
  useEffect(() => {
    if (!valid) return;
    let live = true;
    void getJson<{ providerCode?: string }>(`/api/admin/ai/connections/${value}`).then((reply) => {
      if (!live) return;
      const code = reply.status === 200 ? reply.body?.providerCode : null;
      navigate(
        code ? `/Ai/Providers/${encodeURIComponent(code)}${addKey ? "?conectar=1" : ""}` : "/Ai/Providers/Index",
        { replace: true },
      );
    });
    return () => {
      live = false;
    };
  }, [valid, value, addKey, navigate]);
  if (!valid) return <Navigate replace to="/Ai/Providers/Index" />;
  return <Loading label={L("NPA_LOADING")} />;
}
